import { lazy } from 'react';

import type { ModuleWeb } from '../registry.js';

const page = <T extends string>(
  load: () => Promise<Record<T, () => React.ReactElement>>,
  name: T,
) => lazy(() => load().then((m) => ({ default: m[name] })));

const pages = () => import('./TelephoniePages.js');
const PostesPage = page(pages, 'PostesPage');
const FilesPage = page(pages, 'FilesPage');
const HorairesPage = page(pages, 'HorairesPage');
const SonsPage = page(pages, 'SonsPage');
const AdministrationPage = page(pages, 'AdministrationPage');
const centre = () => import('./CentreAppelPages.js');
const CentreAppelPage = page(centre, 'CentreAppelPage');
const JournalPage = page(centre, 'JournalPage');
const MonTelephonePage = page(centre, 'MonTelephonePage');
const OasisCallAdminPage = page(() => import('./OasisCallAdminPage.js'), 'OasisCallAdminPage');
const BasculesPage = page(() => import('./BasculesPage.js'), 'BasculesPage');
const SupervisionPage = page(() => import('./SupervisionPage.js'), 'SupervisionPage');

/** Routes du module Téléphonie (module.json `navigation`, spec 013). */
export const telephonieWeb: ModuleWeb = {
  module: 'telephonie',
  routes: [
    { path: '/telephonie/postes', element: <PostesPage /> },
    { path: '/telephonie/files', element: <FilesPage /> },
    { path: '/telephonie/horaires', element: <HorairesPage /> },
    { path: '/telephonie/sons', element: <SonsPage /> },
    { path: '/telephonie/administration', element: <AdministrationPage /> },
    { path: '/telephonie/centre-appel', element: <CentreAppelPage /> },
    { path: '/telephonie/journal', element: <JournalPage /> },
    { path: '/telephonie/mon-poste', element: <MonTelephonePage /> },
    { path: '/telephonie/administration/oasiscall', element: <OasisCallAdminPage /> },
    { path: '/telephonie/administration/bascules', element: <BasculesPage /> },
    { path: '/telephonie/supervision', element: <SupervisionPage /> },
  ],
};
